import { Input, LabelledField } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { CompetitionRegistrationPageController } from "../controllers/CompetitionRegistrationPageController";

const MobileNumberForm = () => {
  const controller = CompetitionRegistrationPageController.use();
  const { formData } = controller.state;

  return (
    <>
      <p className="mb-4 text-gray-600">
        Your email has been verified. Please provide your mobile number (optional) for tournament
        communications.
      </p>

      <LabelledField
        label="Mobile Number"
        helpText="Your mobile number will be shared with the tournament organizer for important updates."
      >
        <Input
          type="tel"
          value={formData.mobile}
          onChange={(e) => (controller.state.formData.mobile = e.target.value)}
          showValid
        />
      </LabelledField>
    </>
  );
};

export default ApplicationView(MobileNumberForm);
